import React from 'react';
import './footer.css';

const footer = () => {
  return (
    <footer className='footer'>
       <p>Copyright @2026 Created by  <a href='https://www.linkedin.com/in/mohammad-hussain-769610281/'> <strong> ME </strong> </a></p>
    </footer>
  )
}

export default footer
